import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import BatteryFullIcon from '@material-ui/icons/BatteryFull';
import Battery90Icon from '@material-ui/icons/Battery90';
import Battery80Icon from '@material-ui/icons/Battery80';
import Battery60Icon from '@material-ui/icons/Battery60';
import Battery50Icon from '@material-ui/icons/Battery50';
import Battery30Icon from '@material-ui/icons/Battery30';
import Battery20Icon from '@material-ui/icons/Battery20';
import BatteryAlertIcon from '@material-ui/icons/BatteryAlert';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  high: {
    fill: '#26A66A',
  },
  med: {
    fill: '#FFCB75',
  },
  low: {
    fill: '#E04828',
  },
  text: {
    marginLeft: 5,
  },
}));

const BatteryInfo = ({ battery, showText }) => {
  const classes = useStyles();
  const getIconByLevel = (level) => {
    if (level >= 125) {
      return <BatteryFullIcon className={classes.high} />;
    }
    if (level >= 122) {
      return <Battery60Icon className={classes.med} />;
    }
    return <Battery20Icon className={classes.low} />;
  };

  return <div className={showText ? classes.container : ''}>{getIconByLevel(battery)}</div>;
};

BatteryInfo.propTypes = {
  battery: PropTypes.number.isRequired,
  showText: PropTypes.bool,
};
BatteryInfo.defaultProps = {
  showText: false,
};

export default BatteryInfo;
